/* esm.sh - applesauce-common@5.2.0/dist/blueprints/poll */
export * from "/*applesauce-common@5.2.0/esnext/dist/blueprints/poll.mjs";
